import PasswordReset from './PasswordReset';
import './PasswordReset.scss';

export default PasswordReset;
